import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

export const DialogBody = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
    width: 100%;
`;

export const DialogTitle = styled.div`
    font-size: 20px;
    font-weight: 400;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0 1rem 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.branding.gray.light};
    box-shadow: rgba(0, 0, 0, 0.16) 0 1px 4px;
`;

export const DialogStyled = styled(Dialog)`
    [role='dialog'] {
        min-width: 600px;
        max-width: max-content;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
